var map = {
	"./decidim/avatar-multiuser.png": 5396,
	"./decidim/brands/google.svg": 9236,
	"./decidim/cc-badge.png": 1202,
	"./decidim/decidim-logo.svg": 2538,
	"./decidim/default-avatar.svg": 3130,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 82,
	"./decidim/icons.svg": 831,
	"./decidim/pattern.png": 6101,
	"./decidim/placeholder-card-g.svg": 2667,
	"./decidim/placeholder-card-l.svg": 2747,
	"./decidim/placeholder.jpg": 9939,
	"./decidim/remixicon.symbol.svg": 5724,
	"./decidim/vendor/leaflet/layers-2x.png": 9842,
	"./decidim/vendor/leaflet/layers.png": 1335,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 7594,
	"./decidim/vendor/leaflet/marker-icon.png": 388,
	"./decidim/vendor/leaflet/marker-shadow.png": 2621,
	"./decidim/vendor/social-share-button/douban.svg": 6563,
	"./decidim/vendor/social-share-button/email.svg": 7172,
	"./decidim/vendor/social-share-button/facebook.svg": 6175,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 9451,
	"./decidim/vendor/social-share-button/hacker_news.svg": 3588,
	"./decidim/vendor/social-share-button/linkedin.svg": 4458,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 3461,
	"./decidim/vendor/social-share-button/pinterest.svg": 280,
	"./decidim/vendor/social-share-button/reddit.svg": 3650,
	"./decidim/vendor/social-share-button/telegram.svg": 9384,
	"./decidim/vendor/social-share-button/tumblr.svg": 6458,
	"./decidim/vendor/social-share-button/twitter.svg": 530,
	"./decidim/vendor/social-share-button/vkontakte.svg": 1087,
	"./decidim/vendor/social-share-button/wechat.svg": 5187,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9485,
	"./decidim/vendor/social-share-button/x.svg": 1186,
	"./decidim/vendor/social-share-button/xing.svg": 7765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;